
//.递归组件向外传递数据直接用$emit是无法实现的。因为是递归的原因。
// emit和on的事件必须在一个公共的实例上，才能够触发
// 用于递归组件Tree传值给父组件
import Vue from 'vue';  
export default new Vue(); 